import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import MenuItem from '../shared/interfaces/menuItems.interface';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private readonly mainMenuSource = new BehaviorSubject<MenuItem[]>([]);
  mainMenu$ = this.mainMenuSource.asObservable();

  setMainMenu(menu: MenuItem[]) {
    this.mainMenuSource.next(menu);
  }
}
